import { ReportToTonn } from './ReportToTonn';

export default ReportToTonn;
